import { createContext } from "react";
import projectsData from "../data/projectsData";

// create the context
const DataContext = createContext();

// create the provider
const DataContextProvider = ({children}) => {

    const getProject = (slug) => {
        let tempData = projectsData;
        let project = tempData.find(item => item.slug === slug);

        return project
    }

    return (
        <DataContext.Provider value={{projectsData, getProject}}>
            {children} 
        </DataContext.Provider>
    )
}

export { DataContext, DataContextProvider }